'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    Analytics = require('../utils/Analytics');

let currentPath = null;

var RouterActionCreators = {
  changeRoute(routerState) {
    const { path, routes, params } = routerState;

    if (module.hot && currentPath === path) {
      // Only fire an action if the path has really changed.
      // This will always be true except when hot reloading routes.
      return;
    }

    currentPath = path;

    AppDispatcher.handleViewAction({
      type: ActionTypes.CHANGE_ROUTE,
      routerState: routerState
    });

    Analytics.trackPageView(path, routes, params);
  }
};

module.exports = RouterActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/RouterActionCreators.js
 **/